import { HierarchyUtils, TransformUtils } from '@inter-ikea-core/core';
import { AdjustableComponent, EntityApi, isOutsideClothRail } from '@inter-ikea-storageone/range';
export class AurdalEntityApi extends EntityApi {
    /**
     * @override
     */
    duplicate(entity) {
        const worldPosition = TransformUtils.worldPosition(entity);
        const clone = HierarchyUtils.duplicateEntity(entity, this.core.services);
        this.deleteExternalClothRails(clone);
        let result = this.placementService.snapToPosition(clone, worldPosition, false);
        if (!result.placedEntity) {
            // If not possible to snap the clone to the position of the original, try to snap it to scene
            result = this.placementService.snapToScene(clone);
        }
        if (!result.placedEntity) {
            // If not possible to place the clone at all, dispose it
            this.core.services.entityManager.disposeEntity(clone);
        }
        return result;
    }
    /**
     * Delete external cloth rails from the clone entity.
     * @param clone The clone entity to filter
     */
    deleteExternalClothRails(clone) {
        this.deleteMultiple(HierarchyUtils.getDescendantsWithComponent(clone, AdjustableComponent.id).filter(e => isOutsideClothRail(e)));
    }
}
//# sourceMappingURL=AurdalEntityApi.js.map